import Swal from "sweetalert2";

/**
 * Hiển thị thông báo xác nhận xóa linh hoạt bằng SweetAlert2
 * @param {Object} options - Các tùy chọn cho thông báo
 * @param {string} options.title - Tiêu đề thông báo (mặc định: "Bạn có chắc chắn muốn xóa?")
 * @param {string} options.text - Nội dung chi tiết (mặc định: "Hành động này không thể hoàn tác!")
 * @param {string} options.confirmButtonText - Chữ trên nút xác nhận (mặc định: "Xóa ngay")
 * @param {string} options.cancelButtonText - Chữ trên nút hủy (mặc định: "Hủy bỏ")
 * @param {Function} options.onConfirm - Hàm callback sẽ chạy khi người dùng nhấn "Xóa"
 */
export const showDeleteAlert = ({
  title = "Bạn có chắc chắn muốn xóa?",
  text = "Hành động này không thể hoàn tác!",
  confirmButtonText = "Xóa ngay",
  cancelButtonText = "Hủy bỏ",
  onConfirm = () => {},
}) => {
  Swal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc2626", // Màu đỏ của Tailwind (red-600)
    cancelButtonColor: "#6b7280",  // Màu xám của Tailwind (gray-500)
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    reverseButtons: true, // Đảo vị trí nút Hủy sang trái, Xóa sang phải
    customClass: {
      popup: "swal2-rounded-14",
      confirmButton: "swal2-confirm-btn",
      cancelButton: "swal2-cancel-btn",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    }
  });
};

/**
 * Hiển thị thông báo thành công sau khi xóa
 * @param {string} message - Nội dung thông báo thành công
 */
export const showSuccessAlert = (message = "Đã xóa thành công!") => {
  Swal.fire({
    title: "Thành công!",
    text: message,
    icon: "success",
    timer: 2000,
    showConfirmButton: false,
    timerProgressBar: true,
  });
};

/**
 * Hiển thị thông báo lỗi nếu xóa thất bại
 * @param {string} message - Nội dung thông báo lỗi
 */
export const showErrorAlert = (message = "Đã xảy ra lỗi khi thực hiện thao tác này.") => {
  Swal.fire({
    title: "Thất bại!",
    text: message,
    icon: "error",
    confirmButtonText: "Đóng",
    confirmButtonColor: "#2563eb",
  });
};
